import SubscriptionInfoStore, { loadAllData as LoadAllSubscriptions } from './EquipmentOverview/subscriptionInfo';
import LatestInfoStore, { loadLatestData as LoadLatestVehicleData, loadLatestDataFromCdc, reLoadPositionData } from './EquipmentOverview/latestInfo';
import CommunicatorInfoStore, { loadCommunicatorData } from './EquipmentOverview/communicatorInfo';
import UniversalSearchStore from './EquipmentOverview/universalSearch';
export * as UniversalSearchActions from './EquipmentOverview/universalSearch';
import { createSelectorHook, useDispatch } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import { default as CustomerOverview, loadCustomerData } from './EquipmentOverview/customerInfo';
// import CustomerOverview from '../components/CustomerOverview';
import { default as CustomerInfoStore, loadCustomerData } from './EquipmentOverview/customerInfo';
export var useAppDispatch = useDispatch;
export { SubscriptionInfoStore, LoadAllSubscriptions, LatestInfoStore, LoadLatestVehicleData, reLoadPositionData, CommunicatorInfoStore, loadCommunicatorData, UniversalSearchStore, CustomerInfoStore, loadCustomerData, loadLatestDataFromCdc };
var reducer = combineReducers({
    SubscriptionInfoStore: SubscriptionInfoStore,
    LoadAllSubscriptions: LoadAllSubscriptions,
    LatestInfoStore: LatestInfoStore,
    LoadLatestVehicleData: LoadLatestVehicleData,
    reLoadPositionData: reLoadPositionData,
    CommunicatorInfoStore: CommunicatorInfoStore,
    loadCommunicatorData: loadCommunicatorData,
    universalSearch: UniversalSearchStore,
    CustomerInfoStore: CustomerInfoStore,
    loadCustomerData: loadCustomerData,
});
var store = configureStore({ reducer: reducer });
export var useAppSelector = createSelectorHook();
